import { FlexDiv, FlexRowDiv } from '@/app/shared/common.StyledComponents';
import {
  Paragraph,
} from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import { PaymentInstructionDetails } from './paymentInstructions.types';
import { CheckPaymentDetailsSection } from './paymentInstructions.StyleComponents';
import { CopyToClipboardButton } from '@/app/shared/components/ClipboardCopy/ClipboardCopyButton';

export const PaymentInstructionDetail: React.FC<PaymentInstructionDetails> = ({
  company,
}) => {
  const { t } = useTranslation('invoicesDashboard');

  // Error handling: if the selected company / its payment instructions are not
  // available, surface a user-facing message instead of crashing
  // (FACOPS-2531 acceptance criteria).
  if (!company?.paymentInstructions) {
    return (
      <CheckPaymentDetailsSection>
        <Paragraph data-testid="payment-instruction-error">
          <br /> {t('paymentDetails.loadError')}
        </Paragraph>
      </CheckPaymentDetailsSection>
    );
  }

  const { ach, remittance } = company.paymentInstructions;

  return (
    <CheckPaymentDetailsSection>
        <Paragraph>
            <br/> {t('paymentDetails.header', { companyName: company.name })}
        </Paragraph>
        <FlexRowDiv>
            <FlexDiv>
                <Paragraph>
                      <b>{t('paymentDetails.achWireHeader')}</b><br/>
                      <CopyToClipboardButton value={ach.bankName}/>
                      <CopyToClipboardButton value={ach.abaNumber} displayText={t('paymentDetails.abaHeader') + ach.abaNumber}/>
                      <CopyToClipboardButton value={ach.accountNumber} displayText={t('paymentDetails.accountNumberHeader') + ach.accountNumber}/>
                      <CopyToClipboardButton value={remittance.email} displayText={t('paymentDetails.remitEmailHeader') + remittance.email}/>
                      {remittance.mailingAddress && (
                        <>
                          {t('paymentDetails.orSeparator')}<br/>
                          <CopyToClipboardButton
                            value={remittance.mailingAddress.lines.join('\n')}
                            displayText={remittance.mailingAddress.lines.join(', ')}
                          />
                        </>
                      )}
                </Paragraph>
            </FlexDiv>
        </FlexRowDiv>
    </CheckPaymentDetailsSection>
  );
};
